import PropTypes from 'prop-types';
import React from 'react';
import Concatenate from 'components/Concatenate';
import {FormattedMessage} from 'react-intl';
import StringValueInputModal from './StringValueInputModal';
import ButtonUnstyled from 'components/ButtonUnstyled';

class StringValueInput extends React.Component {
  constructor(props) {
    super(...arguments);

    this.state = {
      isOpen: props.selected,
    };
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next.selected !== this.props.selected) {
      this.setState({
        isOpen: next.selected,
      });
    }
  }

  handleSelect = values => {
    this.props.onInputChange(values);
  };

  handleClick = () => {
    this.setState({
      isOpen: true,
    });
  };

  handleRequestModalClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const {column, values, dataSourceId, pageId, cardId} = this.props;
    const isEmpty = values.length === 0;
    const content = isEmpty ? (
      <FormattedMessage
        id="StringValueInput__EmptyPlaceholder"
        description="Instruct a user to select values using this component"
        defaultMessage="Select Values"
      />
    ) : (
      <Concatenate>{values}</Concatenate>
    );
    return (
      <React.Fragment>
        <ButtonUnstyled onClick={this.handleClick}>{content}</ButtonUnstyled>
        <StringValueInputModal
          cardId={cardId}
          column={column}
          dataSourceId={dataSourceId}
          isOpen={this.state.isOpen}
          onRequestModalClose={this.handleRequestModalClose}
          onSelect={this.handleSelect}
          pageId={pageId}
          values={values}
        />
      </React.Fragment>
    );
  }
}

StringValueInput.propTypes = {
  cardId: PropTypes.string,
  column: PropTypes.object.isRequired,
  dataSourceId: PropTypes.string,
  onInputChange: PropTypes.func.isRequired,
  pageId: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
};

export default StringValueInput;
